import '../style/intro-B_kr_3rg.css'
import { openBlock as n, createElementBlock as a, createElementVNode as $, defineComponent as N, computed as _, toDisplayString as m, createCommentVNode as k, createBlock as L, resolveDynamicComponent as ie, Fragment as O, renderList as ue, unref as x, withCtx as M, createTextVNode as E, createVNode as B, normalizeClass as Q, ref as T, reactive as ce, onMounted as pe, onBeforeUnmount as he, normalizeStyle as I, withDirectives as de, normalizeProps as j, guardReactiveProps as G, vShow as fe, useModel as ve } from "vue";
import "x-utils";
import "@vueuse/core";
import "lodash-es";
import { useI18n as Z } from "./hooks/useLocale.js";
import "./hooks/useGlobalDark.js";
import "./layout/model/Model.js";
import "./layout/DockLocation.js";
import "./layout/Orientation.js";
import "./layout/model/TabNode.js";
import "./layout/model/TabSetNode.js";
import "./layout/model/BorderNode.js";
import { Button as R } from "./button.js";
const me = (h, i) => {
  const t = h.__vccOpts || h;
  for (const [o, p] of i)
    t[o] = p;
  return t;
}, ye = {}, _e = { class: "e-intro-dot" }, we = /* @__PURE__ */ $("div", { class: "e-intro-dot__border" }, null, -1), xe = /* @__PURE__ */ $("div", { class: "e-intro-dot__circle" }, null, -1), ke = [
  we,
  xe
];
function $e(h, i) {
  return n(), a("div", _e, ke);
}
const ge = /* @__PURE__ */ me(ye, [["render", $e]]), Ce = { class: "e-intro__content" }, Se = {
  key: 0,
  class: "e-intro__content-header"
}, be = {
  key: 2,
  class: "e-intro__content-body"
}, Be = { class: "content-index" }, Le = { class: "content-text" }, De = {
  key: 3,
  class: "e-intro__content-body"
}, J = /* @__PURE__ */ N({
  __name: "intro-content",
  props: {
    title: {},
    content: {}
  },
  setup(h) {
    const i = h, t = _(() => !(typeof i.content == "string" || Array.isArray(i.content)));
    return (o, p) => (n(), a("div", Ce, [
      o.title ? (n(), a("div", Se, m(o.title), 1)) : k("", !0),
      t.value ? (n(), L(ie(o.content), { key: 1 })) : Array.isArray(o.content) ? (n(), a("div", be, [
        (n(!0), a(O, null, ue(o.content, (s, d) => (n(), a("div", {
          key: d,
          class: "content-item"
        }, [
          $("div", Be, m(d + 1) + ". ", 1),
          $("div", Le, m(s), 1)
        ]))), 128))
      ])) : (n(), a("div", De, m(o.content), 1))
    ]));
  }
}), Ee = { class: "e-intro__actions" }, K = /* @__PURE__ */ N({
  __name: "intro-actions",
  props: {
    step: {},
    nextButtonText: {},
    isLastStep: { type: Boolean },
    handleClose: { type: Function },
    handleNext: { type: Function }
  },
  setup(h) {
    const { t: i } = Z();
    return (t, o) => (n(), a("div", Ee, [
      t.isLastStep ? k("", !0) : (n(), L(x(R), {
        key: 0,
        class: "skip",
        size: "sm",
        text: "",
        onClick: o[0] || (o[0] = (p) => t.handleClose(!0))
      }, {
        default: M(() => [
          E(m(x(i)("common.skip")), 1)
        ]),
        _: 1
      })),
      t.step > 0 ? (n(), L(x(R), {
        key: 1,
        class: "back",
        size: "sm",
        text: "",
        onClick: o[1] || (o[1] = (p) => t.handleNext(!0))
      }, {
        default: M(() => [
          E(m(x(i)("common.back")), 1)
        ]),
        _: 1
      })) : k("", !0),
      B(x(R), {
        size: "sm",
        class: Q(t.isLastStep ? "ok" : "next"),
        onClick: o[2] || (o[2] = (p) => t.handleNext(!1))
      }, {
        default: M(() => [
          t.nextButtonText ? (n(), a(O, { key: 0 }, [
            E(m(t.nextButtonText), 1)
          ], 64)) : (n(), a(O, { key: 1 }, [
            E(m(t.isLastStep ? x(i)("common.ok") : x(i)("common.next")), 1)
          ], 64))
        ]),
        _: 1
      }, 8, ["class"])
    ]));
  }
}), Te = { class: "e-intro" }, Ie = {
  key: 0,
  class: "e-intro__step"
}, Ne = {
  key: 0,
  class: "e-intro__step"
}, Ve = /* @__PURE__ */ N({
  __name: "intro",
  props: {
    showLayer: { type: Boolean, default: !0 },
    stepsConfig: {},
    showStep: { type: Boolean, default: !0 },
    stepHook: {},
    retryCount: { default: 0 },
    showDot: { type: Boolean }
  },
  emits: ["close", "step-change", "layer-click"],
  setup(h, { emit: i }) {
    const t = h, o = i, { t: p } = Z(), s = T(0), d = T(!1), g = T(!1), u = ce({
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      radius: 0
    }), V = _(() => {
      if (d.value)
        return {
          left: `${u.left}px`,
          top: `${u.top}px`,
          width: `${u.width}px`,
          height: `${u.height}px`,
          "border-radius": `${u.radius}px`,
          "box-shadow": t.showLayer ? "0 0 0 10000px rgb(0 0 0 / 60%)" : "none"
        };
      if (g.value)
        return {
          "border-radius": `${u.radius}px`,
          "box-shadow": t.showLayer ? "0 0 0 10000px rgb(0 0 0 / 60%)" : "none"
        };
    }), r = _(() => t.showStep && t.stepsConfig[s.value]?.showStep !== !1), S = _(() => p("common.step") + ` ${s.value + 1}/${t.stepsConfig.length}`), c = _(() => {
      const { stepsConfig: e } = t;
      return s.value < e.length ? e[s.value] : null;
    }), z = _(() => s.value === t.stepsConfig.length - 1), P = _(() => {
      if (c?.value?.width)
        return {
          width: c.value.width
        };
    }), ee = _(() => {
      if (!c.value)
        return;
      const { placement: e, distance: l = 20 } = c.value, { left: f, top: v, width: y, height: w } = u;
      switch (e) {
        case "top":
          return {
            left: `${f + y / 2}px`,
            top: `${v - l}px`,
            transform: "translate(-50%, -100%)"
          };
        case "bottom":
          return {
            left: `${f + y / 2}px`,
            top: `${v + w + l}px`,
            transform: "translateX(-50%)"
          };
        case "left":
          return {
            left: `${f - l}px`,
            top: `${v + w / 2}px`,
            transform: "translate(-100%, -50%)"
          };
        case "right":
          return {
            left: `${f + y + l}px`,
            top: `${v + w / 2}px`,
            transform: "translateY(-50%)"
          };
        case "left-top":
          return {
            left: `${f - l}px`,
            top: `${v}px`,
            transform: "translateX(-100%)"
          };
        case "left-bottom":
          return {
            left: `${f - l}px`,
            top: `${v + w}px`,
            transform: "translate(-100%, -100%)"
          };
        case "right-top":
          return {
            left: `${f + y + l}px`,
            top: `${v}px`
          };
        case "right-bottom":
          return {
            left: `${f + y + l}px`,
            top: `${v + w}px`,
            transform: "translateY(-100%)"
          };
        default:
          return;
      }
    }), te = _(() => ({
      ...P.value,
      ...ee.value
    })), X = ["orientationchange", "resize", "scroll"];
    let A = !1;
    pe(() => {
      D(), X.forEach((e) => {
        window.addEventListener(e, b);
      }), window.screen.orientation?.addEventListener("change", b);
    }), he(() => {
      X.forEach((e) => {
        window.removeEventListener(e, b);
      }), window.screen.orientation?.removeEventListener("change", b);
    });
    function b() {
      A && D();
    }
    function H(e) {
      const { stepHook: l } = t;
      e && l && l(-1), o("close", { skip: e, stepIndex: s.value });
    }
    function oe() {
      o("layer-click", {
        skip: !0
      });
    }
    function F(e) {
      if (e)
        s.value--;
      else if (!z.value)
        s.value++;
      else {
        H(!1);
        return;
      }
      D();
    }
    let Y = 0;
    function D() {
      if (!c.value)
        return;
      o("step-change", { stepIndex: s.value });
      const { stepHook: e } = t;
      e && e(s.value);
      const { selector: l, padding: f = 0, radius: v = 8 } = c.value;
      if (l) {
        const y = document.querySelector(l);
        if (g.value = !1, d.value = !1, y) {
          A = !0;
          const { left: w, top: q, right: se, bottom: re, width: U, height: W } = y.getBoundingClientRect(), { clientWidth: le, clientHeight: ae } = document.documentElement;
          if (w >= 0 && q >= 0 && se <= le && re <= ae && U && W) {
            const C = ne(f);
            u.left = w - C[3], u.top = q - C[0], u.width = U + C[1] + C[3], u.height = W + C[0] + C[2], u.radius = v, d.value = !0;
          } else e || (y.scrollIntoView({
            block: "center",
            inline: "center"
          }), b());
        } else
          A = !1, ++Y > t.retryCount ? (Y = 0, F(!1)) : setTimeout(D, 100);
      } else
        d.value = !1, g.value = !0;
    }
    function ne(e) {
      return typeof e == "number" ? [e, e, e, e] : e.length === 2 ? [e[0], e[1], e[0], e[1]] : e.length === 3 ? [e[0], e[1], e[2], e[1]] : e;
    }
    return (e, l) => (n(), a("div", Te, [
      $("div", {
        class: "e-intro__overlay",
        onClick: oe
      }),
      $("div", {
        class: "e-intro__helper",
        style: I(V.value)
      }, null, 4),
      de($("div", {
        class: Q(["e-intro__tooltip", c.value?.placement]),
        style: I(te.value)
      }, [
        r.value ? (n(), a("div", Ie, m(S.value), 1)) : k("", !0),
        B(J, j(G(c.value)), null, 16),
        B(K, {
          step: s.value,
          "is-last-step": z.value,
          "next-button-text": c.value?.nextButtonText,
          "handle-close": H,
          "handle-next": F
        }, null, 8, ["step", "is-last-step", "next-button-text"])
      ], 6), [
        [fe, d.value]
      ]),
      g.value ? (n(), a("div", {
        key: 0,
        class: "e-intro__modal",
        style: I(P.value)
      }, [
        r.value ? (n(), a("div", Ne, m(S.value), 1)) : k("", !0),
        B(J, j(G(c.value)), null, 16),
        B(K, {
          step: s.value,
          "is-last-step": z.value,
          "next-button-text": c.value?.nextButtonText,
          "handle-close": H,
          "handle-next": F
        }, null, 8, ["step", "is-last-step", "next-button-text"])
      ], 4)) : k("", !0)
    ]));
  }
}), ze = { class: "e-intro-wrapper" }, Ge = /* @__PURE__ */ N({
  name: "e-intro",
  inheritAttrs: !1,
  __name: "intro-wrapper",
  props: {
    modelValue: { type: Boolean },
    showLayer: { type: Boolean, default: !0 },
    stepsConfig: {},
    showStep: { type: Boolean, default: !0 },
    stepHook: {},
    retryCount: { default: 0 },
    showDot: { type: Boolean }
  },
  emits: ["close", "step-change", "layer-click"],
  setup(h, { emit: i }) {
    const t = h, o = ve(t, "modelValue"), p = i, s = T(t.showDot), d = () => {
      o.value = !1;
    }, g = (r) => {
      p("layer-click", r);
    }, u = (r) => {
      d(), p("close", r);
    }, V = (r) => {
      p("step-change", r);
    };
    return (r, S) => (n(), a("div", ze, [
      r.showDot ? (n(), L(ge, {
        key: 0,
        style: I({ visibility: s.value ? "visible" : "hidden" }),
        onClick: S[0] || (S[0] = (c) => {
          o.value = !0, s.value = !1;
        })
      }, null, 8, ["style"])) : k("", !0),
      x(o) ? (n(), L(Ve, {
        key: 1,
        "show-layer": r.showDot ? !1 : r.showLayer,
        "steps-config": r.stepsConfig,
        "show-step": r.showStep,
        "step-hook": r.stepHook,
        "retry-count": r.retryCount,
        onLayerClick: g,
        onClose: u,
        onStepChange: V
      }, null, 8, ["show-layer", "steps-config", "show-step", "step-hook", "retry-count"])) : k("", !0)
    ]));
  }
});
export {
  Ge as default
};
//# sourceMappingURL=intro.js.map
